import { StoryBoxSkeleton } from './StoryBoxSkeleton';

/**
 * Skeleton for story list.
 * Shows multiple story skeletons.
 */
export const StoryListSkeleton = ({ count = 3 }: { count?: number }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <StoryBoxSkeleton key={index} index={index} />
      ))}
    </>
  );
};
